import Enums from 'utils/EnumsManager';

const { META_DATA } = Enums.REDUX_ACTION_TYPE_PREFIX;
const PREFIX = 'FIELDS';

export const SET_DATA = `${META_DATA}_${PREFIX}_SET_DATA`;
export const SET_FETCH_STATUS = `${META_DATA}_${PREFIX}_SET_FETCH_STATUS`;



// WEBPACK FOOTER //
// ./src/store/metaData/fields/actionTypes.js